import { iconMapping } from "app/constants/ReportTypeConstant";
import { ReportNavCard } from "app/features/reporting/molecules/ReportNavCard";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { usePathname } from "expo-router";
import { Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import GoBack from "ui/molecules/common/GoBack";
import { AssessmentHistoryTemplate } from "./AssessmentHistoryTemplate";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FileIcon } from "ui/gluestack/icon/File";
import { PermissionCheck } from "../../permission/atoms/PermissionCheck";
import { PermissionsEnums } from "../../../services/api/types/authorisation/enums/PermissionsEnums";
import { useFormsWithOffline } from "../../offline/hooks/useFormsWithOffline";

export function DailyReportsTemplate() {
  const { resident } = useResidentContext();
  const pathname = usePathname();

  const filter = { tag: FormEnums.DAILY_REPORTING };

  const { data: forms, isFetching } = useFormsWithOffline(filter);

  if (isFetching) {
    return <LoadingSpinner />;
  }

  const newPath = pathname.split("/").slice(0, -1).join("/");

  return (
    <View className="resident-container">
      <View className="self-start mt-4 mb-12">
        <GoBack path={newPath} />
      </View>
      <Text className="mb-6 text-base">Daily Reporting</Text>

      <View className="resident-container grid sm:grid-cols-2 gap-4 mb-9">
        <PermissionCheck permission={PermissionsEnums.VIEW_FORM}>
          {forms?.map((form, index) => {
            const IconComponent = iconMapping[form.name] ?? FileIcon;
            const href = `${pathname}/${form.id}`;

            return (
              <ReportNavCard
                key={index}
                icon={IconComponent}
                label={form.name}
                href={href}
              />
            );
          })}
        </PermissionCheck>
      </View>
      <PermissionCheck permission={PermissionsEnums.VIEW_FORM_ENTRIES}>
        <AssessmentHistoryTemplate
          tag={FormEnums.DAILY_REPORTING}
          residentId={resident?.id}
        />
      </PermissionCheck>
    </View>
  );
}
